export const HONORARIES_FILTERS_KEY = 'relatorios.honorarios';

export const FILTER_LABELS = {
  higher_billing_or_employees: 'Fat. ou func. superior',
  higher_billing_and_employees: 'Fat. e func. superior',
  higher_billing: 'Faturamento superior',
  higher_employees: 'Funcionários superior',
  flaggeds: 'Com flag',
};

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
// `filter` is null (not undefined) so it survives JSON and compares with the saved value.
export const getDefaultHonorariesFilters = () => ({
  year: new Date().getFullYear(),
  filter: null,
});

// Saved years come back from JSON; make sure the request/compare always uses a number.
export const getHonorariesYear = (filters) => parseInt(filters.year, 10);

// The IndexedDB cache is keyed by route only, so it only holds the current year.
export const usesHonorariesCache = (filters, defaults) =>
  getHonorariesYear(filters) === getHonorariesYear(defaults);

// Badge: only what differs from the defaults.
export const countActiveHonorariesFilters = (filters, defaults) =>
  (usesHonorariesCache(filters, defaults) ? 0 : 1) + (filters.filter ? 1 : 0);

export const filterHonorariesCustomers = (customers, filter) => {
  const list = customers || [];
  if (!filter) return list;
  return list.filter(({ is_average_billing_higher, is_average_employees_higher, is_flagged }) => {
    switch (filter) {
      case 'flaggeds':
        return is_flagged;
      case 'higher_billing_or_employees':
        return is_average_billing_higher || is_average_employees_higher;
      case 'higher_billing_and_employees':
        return is_average_billing_higher && is_average_employees_higher;
      case 'higher_billing':
        return is_average_billing_higher;
      case 'higher_employees':
        return is_average_employees_higher;
      default:
        return true;
    }
  });
};
